<script setup lang="ts">
import type { Waves } from '@/lib/trashsim/waves';
import { computed } from 'vue';

const props = defineProps<{
    modelValue: number
    waves: Waves
}>()

const emits = defineEmits<{
    (e: 'update:modelValue', value: number): void
    (e: 'submit'): void
    (e: 'next'): void
    (e: 'clear'): void
}>()

const isNextAllowed = computed(() => props.modelValue - 1 < props.waves.length && props.waves[props.modelValue].result != null);

const next = () => isNextAllowed && emits('next')
const previous = () => (props.modelValue) > 0 && emits('update:modelValue', props.modelValue-1)
const clear = () => emits('clear')

</script>

<template>
    <div id="actions-bottom">
        <div id="simulate-button-bottom" class="btn btn-light" @click="$emit('submit')">{{ $t('home.simulate') }}</div>
        <div id="wave-buttons">
            <div class="btn btn-light btn-wave" v-bind:class="{active: modelValue > 0}" @click="previous">
                &lt; {{ $t('home.wave.previous') }}
            </div>
            <div id="wave-current" class="btn btn-light btn-wave active">
                {{ modelValue + 1 }}
            </div>
            <div class="btn btn-light btn-wave" v-bind:class="{active: isNextAllowed}" @click="next">
                {{ $t('home.wave.next') }} &gt;
            </div>
            <div id="wave-clear" class="btn btn-light btn-wave" v-bind:class="{active: waves.length > 1}" @click="clear">
                x {{ $t('home.waves.clear') }}
            </div>
        </div>
    </div>
</template>